const integrationMenu = [
  {
    System: 'INT',
    isActive: true,
    menu: [
      { is_header: true, title: 'التكــامل مع الأنظمة', isActive: true },

      {
        path: '/INT/HomePage',
        icon: 'fas fa-home',
        title: 'HomePage',
        isActive: true
      },
      {
        path: '/INT/Integration',
        icon: 'fas fa-home',
        title: 'التكامل',
        isActive: true
      },
      {
        path: '/INT/IntegrationZatca',
        icon: 'fas fa-home',
        title: 'الربط مع هيئـة الزكاة والدخل',
        isActive: true
      }
    ]
  }
];

export default integrationMenu;
